
class CacheKeyBuilder {
    buildFromHttpRequest({ url, body }) {
        if (typeof body === "string") {
            try {
                body = JSON.parse(body);
            } catch (e) {
            }
        }
        const keyParts = [
            url,
            this.stableStringify(body)
        ];
        return this.hashObject(keyParts.join("|"));
    }

    stableStringify(obj) {
        if (obj === null || typeof obj !== "object") {
            return JSON.stringify(obj);
        }

        if (Array.isArray(obj)) {
            return `[${obj.map(x => this.stableStringify(x)).join(",")}]`;
        }

        const keys = Object.keys(obj).sort();
        return `{${keys.map(k => JSON.stringify(k) + ":" + this.stableStringify(obj[k])).join(",")}}`;
    }

    async hashObject(obj) {
        const encoder = new TextEncoder();
        const data = encoder.encode(this.stableStringify(obj)); // string → bytes
        const hashBuffer = await crypto.subtle.digest("SHA-256", data); // SHA-256

        // Conversion des bytes en chaîne hexadécimale
        return Array.from(new Uint8Array(hashBuffer))
            .map(b => b.toString(16).padStart(2, "0"))
            .join("");
    }
}

export default CacheKeyBuilder;